import RequestPage from "./RequestPage";

const FeaturePlan = () => {
 return (
        <RequestPage title="Future Plans Request"
            fetchUrl="/get-future-plans-requests"
            editEndpoint="edit-future-plans-request"
            deleteEndpoint="future-plans-request"
            statusEndpoint="future-plans-request" />
    );
}

export default FeaturePlan;